import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { ChallengeQuestActivity, MediaFile } from "src/app/models";

export const loadChallengeQuestActivity = createAction(
  "[Challenge Quest Activity Component] Load activity",
  props<{ activityId: number }>()
);
export const loadChallengeQuestActivitySuccess = createAction(
  "[Challenge Quest Activity Component] Load activity success",
  props<{ activity: ChallengeQuestActivity }>()
);
export const loadChallengeQuestActivityFailure = createAction(
  "[Challenge Quest Activity Component] Load activity failure",
  props<{ error: HttpErrorResponse }>()
);

export const updateActivity = createAction(
  "[Challenge Quest Activity Component] Update activity",
  props<{ activity: ChallengeQuestActivity; mediaFile: File | null }>()
);
export const updateActivitySuccess = createAction(
  "[Challenge Quest Activity Component] Update activity success",
  props<{ activity: ChallengeQuestActivity; mediaFile?: MediaFile }>()
);
export const updateActivityFailure = createAction(
  "[Challenge Quest Activity Component] Update activity failure",
  props<{ error: HttpErrorResponse }>()
);
